module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightpartcloud-8cbd1a68b12e486e2f172494c01e7fca.png";